import React from 'react';
import {
    TeamCard,
    TextWrapper,
    TopLine,
    FormH4,
    SelectButton,
    DetailsWrap,
    StatsWrap,
    ImgWrap,
    Img
} from './TeamDisplayElements';
import teamLogos from '../LogoImageForms/TeamLogos';

const TeamPlayerCard = ({ player, index, handleRemove }) => {
    var position;
    if (player.position === "QB") {
        position = "Quarterback"
    }
    else if (index === 7) {
        position = 'Flex'
    }
    else if (player.position === "RB") {
        position = "Running back"
    }
    else if (player.position === "WR") {
        position = "Wide Receiver"
    }
    else if (player.position === "TE") {
        position = "Tight End"
    }
    else if (player.position === "DST") {
        position = "Defense"
    }


    const logo = teamLogos[player.team];

    return (
        <>

            {/* <TopLine>{position}</TopLine> */}
            <TeamCard>
                {/* <ImgWrap>
                    <Img src={app.img} alt={app.alt} />
                </ImgWrap> */}
                <TextWrapper>
                    <TopLine>{player.name}</TopLine>
                    <DetailsWrap>
                        <ImgWrap>
                            <Img src={logo} alt={player.team} />
                        </ImgWrap>
                        <StatsWrap>
                            <FormH4>{player.position}</FormH4>
                            <FormH4>${player.currentCost}</FormH4>
                            <FormH4>{player.dkPoints} </FormH4>
                        </StatsWrap>
                    </DetailsWrap>
                    {/* <BtnWrap>
                            <BtnLink
                                offset={-80}
                                primary={true}
                                dark={false}
                                dark2={false}
                            >
                                Add
                            </BtnLink>
                        </BtnWrap> */}
                </TextWrapper>
                <SelectButton onClick={handleRemove(player)}>Remove</SelectButton>
            </TeamCard>
        </>
    );
};

export default TeamPlayerCard;
